import { UrlList } from 'app/main/pages/authentication/shared/url-list.enum';
import { BehaviorSubject } from 'rxjs';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
export class CampaignService {
    constructor(_httpClient) {
        this._httpClient = _httpClient;
        this.urlCampaign = UrlList.URL_CAMPAIGN;
        this.onMediaFileChanged = new BehaviorSubject([]);
    }
    validateCampaing(data) {
        return this._httpClient.post(`${this.urlCampaign + '/validate/campaign'}`, data);
    }
    saveCampaign(scheduledMessage) {
        return this._httpClient.post(`${this.urlCampaign + '/create/campaign'}`, scheduledMessage);
    }
}
CampaignService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function CampaignService_Factory() { return new CampaignService(i0.ɵɵinject(i1.HttpClient)); }, token: CampaignService, providedIn: "root" });
